/**
 * 予約情報取得API store サービス
 *
 */
import { Injectable } from '@angular/core';
import {
  CreateSkLkrlStore,
  resetCreateSkLkrl,
  selectCreateSkLkrlState,
  setCreateSkLkrlFromApi,
} from '@common/store/create-sk-lkrl';
import { environment } from '@env/environment';
import { SupportClass } from '@lib/components/support-class';
import { ApiErrorResponseService } from '@lib/services/api-error-response/api-error-response.service';
import {} from '@lib/store';
import { Store, select } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { CreateSkLkrlRequest, DefaultService as ServicingApiService } from 'src/sdk-servicing';

/**
 * 予約情報取得API store サービス
 *
 * store情報
 * @param createSkLkrlData @see CreateSkLkrlState
 */
@Injectable()
export class CreateSkLkrlStoreService extends SupportClass {
  constructor(private store: Store<CreateSkLkrlStore>, private api: ServicingApiService) {
    super();
  }
  public getCreateSkLkrlObservable() {
    return this.store.pipe(
      select(selectCreateSkLkrlState),
      filter((data) => !!data)
    );
  }

  destroy() {}

  public resetCreateSkLkrl() {
    this.store.dispatch(resetCreateSkLkrl());
  }

  public setCreateSkLkrlFromApi(request: CreateSkLkrlRequest) {
    this.store.dispatch(
      setCreateSkLkrlFromApi({
        call: this.api.ordersCreateSkLkrlPost(request),
      })
    );
  }
}
